<template>
  <div class="w-full relative">
    <NuxtLink
      :to="`${baseUrl}${file?.url}`"
      target="_blank"
      rel="noopener noreferrer"
      class="group flex items-center justify-between gap-4 md:gap-6 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_8px_30px_rgb(0,0,0,0.08)] transition-shadow duration-300 px-5 py-4 lg:px-8 lg:py-6"
      :class="[{ 'rounded-3xl': siteSettingsStore.roundCorner }]"
    >
      <!-- Number & Title -->
      <div class="flex items-center gap-4 md:gap-6 w-full">
        <!-- Number -->
        <div
          class="flex shrink-0 w-10 md:w-14 items-center font-saira font-black text-brand-first text-3xl md:text-[40px] leading-none transition-transform duration-300 group-hover:scale-105"
        >
          {{ orderLabel }}
        </div>
        <!-- Title -->
        <div class="text-gray-800 font-bold text-base md:text-lg lg:text-[20px] transition-colors group-hover:text-brand-first line-clamp-2">
          {{ title }}
        </div>
      </div>

      <!-- Download Action -->
      <div class="flex items-center gap-2 md:gap-3 shrink-0">
        <!-- Icon -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          class="w-6 h-6 md:w-8 md:h-8 text-brand-first transition-transform duration-300 group-hover:-translate-y-1"
        >
          <path
            fill="currentColor"
            d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"
          />
        </svg>
        <!-- Text -->
        <span class="hidden lg:block text-sm lg:text-[15px] font-medium text-gray-500 mt-0.5 whitespace-nowrap">
          {{ $t("Download File") }}
        </span>
      </div>
    </NuxtLink>
  </div>
</template>
<script setup>
import { useSiteSettingsStore } from "@/store/index";
const props = defineProps({
  index: { type: Number, default: 0 },
  pin: { type: String },
  title: {
    type: String,
  },
  file: { type: Object },
});

const siteSettingsStore = useSiteSettingsStore();
const runtimeConfig = useRuntimeConfig();
const baseUrl = runtimeConfig.public.baseUrl;
const orderLabel = computed(() =>
  String((props.index || 0) + 1).padStart(2, "0"),
);
</script>
